import { Icon } from "@cloudscape-design/components";

export interface EnvironmentCardItem {
  documentId: string;
  name: string;
  isProduction: boolean;
  stackCount: number;
}

/**
 * Selectable pill/card row for a project's environments (Prod, Dev, Qa, Staging, ...), plus a
 * trailing "add" card to create a new one. Selecting an environment drives the Stacks tab's
 * filter and enables the "Locate stacks" / "Move stacks" actions on ProjectDetailPage. Production
 * always renders with a distinct red accent so it can't be confused with non-prod environments.
 */
export default function EnvironmentCards({
  environments,
  selectedId,
  onSelect,
  onCreate,
}: {
  environments: EnvironmentCardItem[];
  selectedId: string | null;
  onSelect: (id: string | null) => void;
  onCreate: () => void;
}) {
  return (
    <div className="env-cards-row">
      {environments.map((env) => {
        const selected = env.documentId === selectedId;
        return (
          <button
            key={env.documentId}
            type="button"
            className={`env-card ${env.isProduction ? "is-production" : ""} ${selected ? "selected" : ""}`}
            aria-pressed={selected}
            onClick={() => onSelect(selected ? null : env.documentId)}
          >
            <span className="env-card-name">
              {selected && <Icon name="check" variant="inverted" />}
              {env.name}
            </span>
            {env.isProduction && <span className="env-card-prod-badge">Production</span>}
            <span className="env-card-count">
              {env.stackCount} stack{env.stackCount === 1 ? "" : "s"}
            </span>
          </button>
        );
      })}
      <button type="button" className="env-card env-card-add" onClick={onCreate}>
        <span className="env-card-name">
          <Icon name="add-plus" />
          Create environment
        </span>
      </button>
    </div>
  );
}
